var _path, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoolworthsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h150v150H0V0z",
    fill: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M101.1 106.4c-3.1 0-5.9-.4-8.7-1.1-4.5 6.2-10.3 11.5-17 15.2 5.9 3.2 12.6 5.2 19.7 5.2 27.2 0 45.8-28.3 47.9-52.4-.8 3.1-6.4 33.1-41.9 33.1z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M107.9 31.1c-13.1 0-19.4 7.6-19.4 7.6 13.5 1.4 30.1 10.9 30.1 30.7 0 19.2-12.6 27.9-22.8 30.8-1 1.8-2.2 3.5-3.4 5.2 2.4.7 5.7 1.1 8.7 1.1 35.5 0 41.1-30 42-33.2.2-1.6.2-3.2.2-4.8 0-27-20.6-37.4-35.4-37.4z"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M49.8 106.4c7.5 0 14.1-2.3 19.4-6-1.8.5-4 1-6.3 1-10 0-30.6-7.4-30.6-32 0-19.8 16.6-29.3 30.1-30.7 0 0-6.3-7.6-19.4-7.6-14.8 0-35.4 10.3-35.4 37.3 0 1.6.1 3.2.2 4.8.9 3.3 6.4 33.2 42 33.2z"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M63.2 101.9c2.2 0 4.2-.3 6-1.5 2.4-1.7 4.6-3.7 6.4-5.9-1.3-1.6-7.1-9.4-7.1-19.9 0-9.8 5.3-14 7-15.1-3.6-2.7-7.7-3.5-10-3.5-3.7 0-13.8 2.6-16.2 14.1-.1.5-.2.9-.2 1.4-.2 1.9-.4 4-.4 6.4 0 9.2 4.2 18 7.3 23.1 2.6.6 5.1.9 7.2.9z"
  }))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M75.6 46.8c-16.4 0-24.3 12.1-26.3 23.2 2.4-11.5 12.4-13.8 15.3-13.9 3.5-.2 7 .7 10.9 3.3 3.9 2.9 7.3 7.9 7.3 15.8 0 6.8-2.6 13.7-7.3 19.3-5.8 7-14.8 11.9-25.8 11.9-35.6 0-41.1-29.9-42-33.1 2.2 24.1 20.7 52.4 47.9 52.4 26.6 0 46.9-26.8 46.9-49.3.2-15.6-8.7-29.6-26.9-29.6z"
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M76.1 37.7s-5.7-5.5-6.1-12.9c-.2-5.4 2-13.7 10.5-18.3 20-10.7 37.4 4.9 35.4 15 0 0-14.9-6.8-28.7 1.3-10 6-11.1 14.9-11.1 14.9z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: -0.6855,
    y1: 151.3546,
    x2: -0.4228,
    y2: 151.3546,
    gradientTransform: "scale(219.547 -219.547) rotate(44.6286 184.4361 76.8038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55b83b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6d93d"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1 37.7s-5.7-5.5-6.1-12.9c-.2-5.4 2-13.7 10.5-18.3 20-10.7 37.4 4.9 35.4 15 0 0-14.9-6.8-28.7 1.3-10 6-11.1 14.9-11.1 14.9",
    fill: "url(#g)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: -0.0523,
    y1: 149.3787,
    x2: 0.2177,
    y2: 149.3787,
    gradientTransform: "scale(-367.505 367.505) rotate(90 74.5974 74.6769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31ad45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473,
    stopColor: "#a6d93d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6d93d"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2 100.4c-1.8.5-4 1-6.3 1-10 0-30.6-7.4-30.6-32 0-19.8 16.6-29.3 30.1-30.7 0 0-6.3-7.6-19.4-7.6-14.8 0-35.4 10.3-35.4 37.3 0 1.6.1 3.2.2 4.8.9 3.2 6.9 35.2 42.5 35.2 0 .1 17.2-2 18.9-8z",
    fill: "url(#h)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: -0.8076,
    y1: 148.3705,
    x2: -0.5302,
    y2: 148.3705,
    gradientTransform: "matrix(0 181.0287 181.0287 0 -26797.1953 200.6888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#219b49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1868,
    stopColor: "#219b49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7802,
    stopColor: "#a6d93d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6d93d"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 103.4c2.2 0 6.9-1.5 6.9-1.5 2.4-1.7 2.8-5.2 4.6-7.4-1.3-1.6-7.1-9.4-7.1-19.9 0-9.8 5.3-14 7-15.1-3.6-2.7-7.6-4.6-10-4.6-3.7 0-13.9 3.7-16.3 15.2-.1.5-.2.9-.2 1.4-.2 1.9-.4 4-.4 6.4 0 9.2 4.2 18 7.3 23.1 2.7.6 8.2 2.4 8.2 2.4z",
    fill: "url(#i)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: -0.0515,
    y1: 148.7877,
    x2: 0.216,
    y2: 148.7877,
    gradientTransform: "scale(-367.8888 367.8888) rotate(90 74.1968 74.2759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31ad45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473,
    stopColor: "#a6d93d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6d93d"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.9 31.1c-13.1 0-19.4 7.6-19.4 7.6 13.5 1.4 30.1 10.9 30.1 30.7 0 19.2-12.6 27.9-22.8 30.8-3.3 1.7-4 3.3-3.4 5.2 2.4.7 5.6 2.5 8.7 2.5 35.5 0 41.1-31.4 42-34.6.2-1.6.2-3.2.2-4.8 0-27-20.6-37.4-35.4-37.4",
    fill: "url(#j)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 3.2387,
    y1: 149.0476,
    x2: 3.5014,
    y2: 149.0476,
    gradientTransform: "scale(-167.2038 167.2038) rotate(-13.134 -643.4563 92.3274)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#219b49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#219b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6d93d"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.1 106.4c-3.1 0-5.9-.4-8.7-1.1-8.8 3.3-13.3 10.6-17 15.2 5.9 3.2 12.6 5.2 19.7 5.2 27.2 0 45.8-28.3 47.9-52.4-.8 3.1-6.4 33.1-41.9 33.1",
    fill: "url(#k)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4819,
    y1: 150.6052,
    x2: 0.7446,
    y2: 150.6052,
    gradientTransform: "scale(527.6657 -527.6657) rotate(75.153 98.2965 74.929)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#219b49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0549,
    stopColor: "#219b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#a6d93d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6d93d"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6 46.8c-16.4 0-24.3 12.1-26.3 23.2 2.4-11.5 12.4-13.8 15.3-13.9 3.5-.2 7 .7 10.9 3.3 3.9 2.9 7.3 7.9 7.3 15.8 0 6.8-2.6 13.7-7.3 19.3-5.8 7-14.8 11.9-25.8 11.9-35.6 0-41.1-29.9-42-33.1 2.2 24.1 20.7 52.4 47.9 52.4 26.6 0 46.9-26.8 46.9-49.3.2-15.6-8.7-29.6-26.9-29.6",
    fill: "url(#l)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoolworthsLogo);
export default __webpack_public_path__ + "static/media/woolworths-logo.b9a4ba5c5870876d2e2be7fd67b18fcf.svg";
export { ForwardRef as ReactComponent };